angular.module('FYN').service('AmenitiesService', function($http) {

	this.all = function() {
		return $http.get('/api/amenities/all');
	}
	
});